module.exports = __webpack_public_path__ + "static/media/journal_audio.7bdc7906.svg";